(() => {
  if (customElements.get('rnf-product-reviews')) return;
  class RnfProductReviews extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.grid = this.querySelector('[data-rnf-review-grid]');
      this.dialog = this.querySelector('[data-rnf-review-composer]');
      this.resizeObserver = new ResizeObserver(() => this.scheduleLayout());
      this.resizeObserver.observe(this.grid);
      this.observeCards();
      this.addEventListener('click', event => {
        if (event.target.closest('[data-rnf-review-write]')) {
          this.openComposer(event.target.closest('button'));
        } else if (event.target.closest('[data-rnf-review-dismiss]')) {
          this.dialog.close();
        } else if (event.target.closest('[data-rnf-review-more]')) {
          this.showMore();
        }
      },{signal});
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      },{signal});
      this.dialog.addEventListener('close', () => this.closeComposer(),{signal});
      this.dialog.addEventListener('change', event => {
        if (event.target.name !== 'contact[rating]') return;
        this.paintRating(event.target.value);
      },{signal});
      this.paintRating(this.dialog.querySelector('input[name="contact[rating]"]:checked')?.value || 0);
      this.scheduleLayout();
      if (this.dialog.querySelector('[data-rnf-review-result]')) this.openComposer();
    }
    observeCards() {
      this.grid.querySelectorAll('.rnf-pr__cardInner').forEach(inner => this.resizeObserver.observe(inner));
    }
    paintRating(value) {
      this.dialog.querySelectorAll('.rnf-pr__ratingOption').forEach(label=>label.classList.toggle('is-selected',Number(label.querySelector('input').value) <= Number(value)));
    }
    scheduleLayout() {
      if (this.layoutFrame) return;
      this.layoutFrame = requestAnimationFrame(() => {
        this.layoutFrame = null;
        if (!this.isConnected) return;
        const gap = parseFloat(getComputedStyle(this.grid).getPropertyValue('--rnf-pr-gap')) || 14;
        const entries = [...this.grid.children].filter(card => card.matches('.rnf-pr__card')).map(card=>({card,height:Math.ceil(card.querySelector('.rnf-pr__cardInner').getBoundingClientRect().height + 2 + gap)}));
        entries.forEach(({card,height})=>card.style.setProperty('--rnf-pr-span',height));
        this.grid.classList.add('is-masonry');
      });
    }
    showMore() {
      const source = this.querySelector('[data-rnf-review-rest]');
      if (!source) return;
      const cards = [...source.content.children].slice(0,Number(this.dataset.pageSize) || 12);
      const fragment = document.createDocumentFragment();
      cards.forEach(card=>fragment.appendChild(card));
      this.grid.appendChild(fragment);
      this.observeCards();
      this.scheduleLayout();
      cards[0]?.focus({preventScroll:true});
      if (!source.content.children.length) {
        this.querySelector('.rnf-pr__moreWrap').hidden = true;
        source.remove();
      }
    }
    openComposer(opener) {
      if (this.dialog.open) return;
      this.composerOpener = opener;
      this.bodyPadding = document.body.style.paddingRight;
      const gap = Math.max(0,innerWidth - document.documentElement.clientWidth);
      if (gap) document.body.style.paddingRight = `${parseFloat(getComputedStyle(document.body).paddingRight) + gap}px`;
      document.body.classList.add('rnf-pr-compose-open');
      this.dialog.showModal();
      this.dialog.querySelector('[data-rnf-review-result]')?.focus();
    }
    closeComposer() {
      document.body.classList.remove('rnf-pr-compose-open');
      document.body.style.paddingRight = this.bodyPadding || '';
      if (this.composerOpener?.isConnected) this.composerOpener.focus({preventScroll:true});
    }
    disconnectedCallback() {
      if (this.isConnected) return;
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.layoutFrame);
      this.layoutFrame = null;
      if (this.dialog?.open) { this.dialog.close(); this.closeComposer(); }
      this.dispatchEvent(new Event('rnf:reviews:unload'));
    }
  }
  customElements.define('rnf-product-reviews',RnfProductReviews);
})();
